import { render, staticRenderFns } from "./CheckupContainer.vue?vue&type=template&id=16dbffc8"
import script from "./CheckupContainer.vue?vue&type=script&lang=ts"
export * from "./CheckupContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports